function d(e, t) {
  return async (r) => {
    let a = t;
    return typeof t == "function" && (a = await t()), r.headers = {
      ...r.headers,
      ...!r.headers[e] && { [e]: a }
    }, r;
  };
}
export {
  d as addHeaderInterceptor
};
//# sourceMappingURL=add-header-interceptor-factory.js.map
